import React from 'react';
import { 
  TrendingUp, 
  Scale, 
  Building2, 
  Handshake, 
  PieChart, 
  FileCheck 
} from 'lucide-react';
import './Services.css';

// Content mapped from "OUR SPECIALIZATIONS" in the provided document
const SERVICES = [
  { 
    id: 1,
    icon: <PieChart size={32} />, 
    title: "Financial Planning", 
    desc: "Expert financial planning specifically tailored for realty investments to maximize your returns." 
  },
  { 
    id: 2,
    icon: <TrendingUp size={32} />, 
    title: "Investment Advisory", 
    desc: "Strategic real estate investment advisory to help you build generational wealth." 
  },
  { 
    id: 3,
    icon: <Scale size={32} />, 
    title: "Legal Vetting", 
    desc: "Comprehensive legal vetting and documentation support to ensure zero-risk transactions." 
  },
  { 
    id: 4,
    icon: <Building2 size={32} />, 
    title: "Portfolio Management", 
    desc: "End-to-end assistance in property resale and managing your real estate portfolio." 
  },
  { 
    id: 5,
    icon: <Handshake size={32} />, 
    title: "Client Consultations", 
    desc: "Transparent, client-first consultations focusing on long-term partnerships, not just sales." 
  },
  { 
    id: 6,
    icon: <FileCheck size={32} />, 
    title: "Regulatory Assurance", 
    desc: "Ensuring 100% regulatory compliance and transparency in all engagements." 
  },
];

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="container">
        
        {/* Header Section */}
        <div className="section-header">
          <span className="section-subtitle">What We Do</span>
          <h2>Our Specializations</h2>
          <div className="divider"></div>
          <p className="section-desc">
            Property Galleria LLP brings together a strong blend of financial expertise, real estate investment knowledge, and legal assurance.
          </p>
        </div>
        
        {/* Responsive Grid */}
        <div className="services-grid1">
          {SERVICES.map((s) => (
            <div className="service-card1" key={s.id}>
              <div className="icon-wrapper">
                {s.icon}
              </div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              
              {/* Decorative line for hover effect */}
              <div className="card-border-bottom"></div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;